<script>
  import { createEventDispatcher } from 'svelte';
  import Conexoes from '../../Classes/Conexoes.js';
  import Constantes from '../../Classes/Constantes.js';
  import { tenantLogado } from '../../Classes/Stores.js';

  export let agendamentos = [];
  export let horarios = []; 
  
  const dispatch = createEventDispatcher();
  const conexao = new Conexoes();
  $: tenant = $tenantLogado;

  let locaisConfigPorNome = {};
  
  // Função para obter o label correto: local > tenant > padrão
  function obterLabelObservacoes(agendamento) {
    const nomeLocal = agendamento?.local || 'Consultório';
    const localConfig = locaisConfigPorNome[nomeLocal];
    return (localConfig && localConfig.label_observacoes) || (tenant && tenant.label_observacoes) || 'Observações';
  }

  let visaoAgendamentos = 'lista';
  let dataCalendario = new Date();

  let termoBusca = '';
  let filtroLocal = '';
  let filtroPeriodo = 'futuros'; 
  let filtroStatus = 'todos'; // NOVO: todos, aguardando, confirmados, compareceram
  let ordenacao = 'data_asc'; 

  $: locaisDisponiveis = [...new Set(agendamentos.map(a => a.local || 'Consultório'))].sort();

  $: agendamentosProcessados = agendamentos
    .filter(a => {
      if (termoBusca && !a.nome_cliente.toLowerCase().includes(termoBusca.toLowerCase())) return false;
      if (filtroLocal && (a.local || 'Consultório') !== filtroLocal) return false;
      
      if (filtroPeriodo !== 'todos') {
        const dataAgendamento = new Date(a.data_hora);
        const agora = new Date();
        if (filtroPeriodo === 'futuros' && dataAgendamento < agora) return false;
        if (filtroPeriodo === 'passados' && dataAgendamento >= agora) return false;
      }

      // NOVO: Lógica de 3 estados
      if (filtroStatus === 'aguardando' && (a.confirmado == 1 || a.compareceu == 1)) return false;
      if (filtroStatus === 'confirmados' && a.confirmado == 0) return false;
      if (filtroStatus === 'compareceram' && a.compareceu == 0) return false;
      
      return true;
    })
    .sort((a, b) => {
      if (ordenacao === 'data_asc') return a.data_hora.localeCompare(b.data_hora);
      if (ordenacao === 'data_desc') return b.data_hora.localeCompare(a.data_hora);
      if (ordenacao === 'nome_asc') return a.nome_cliente.localeCompare(b.nome_cliente);
      if (ordenacao === 'nome_desc') return b.nome_cliente.localeCompare(a.nome_cliente);
      return 0;
    });

  let agendamentoSelecionado = null;
  let modalAcoesVisivel = false;
  let modalCancelamentoVisivel = false;
  let modalReagendamentoVisivel = false;
  let restaurarHorario = true;
  let novoIdHorario = '';

  function formatarData(str) { const [ano, mes, dia] = str.split(' ')[0].split('-'); return `${dia}/${mes}/${ano}`; }
  function mudarMes(delta) { dataCalendario = new Date(anoAtual, mesAtual + delta, 1); }
  function agendamentosDoDia(dia) {
    if (!dia) return [];
    const dataStr = `${anoAtual}-${String(mesAtual + 1).padStart(2, '0')}-${String(dia).padStart(2, '0')}`;
    return agendamentos.filter(a => a.data_hora.startsWith(dataStr)).sort((a, b) => a.data_hora.localeCompare(b.data_hora));
  }

  $: anoAtual = dataCalendario.getFullYear();
  $: mesAtual = dataCalendario.getMonth();
  $: nomeMesAtual = new Intl.DateTimeFormat('pt-BR', { month: 'long' }).format(dataCalendario).replace(/^\w/, c => c.toUpperCase());
  $: diasNoMes = new Date(anoAtual, mesAtual + 1, 0).getDate();
  $: primeiroDiaDaSemana = new Date(anoAtual, mesAtual, 1).getDay(); 
  
  // Atualizar locaisConfigPorNome quando o tenant for carregado
  $: if (tenant && typeof tenant === 'object') {
    locaisConfigPorNome = (typeof tenant.locais_config_por_nome === 'object') ? tenant.locais_config_por_nome : {};
  } 
  $: diasCalendario = Array.from({ length: primeiroDiaDaSemana }, () => null).concat(Array.from({ length: diasNoMes }, (_, i) => i + 1));

  function abrirAcoesCalendario(agendamento) { agendamentoSelecionado = agendamento; modalAcoesVisivel = true; }
  function iniciarCancelamento(agendamento) { agendamentoSelecionado = agendamento; restaurarHorario = true; modalAcoesVisivel = false; modalCancelamentoVisivel = true; }
  function iniciarReagendamento(agendamento) { agendamentoSelecionado = agendamento; restaurarHorario = true; novoIdHorario = ''; modalAcoesVisivel = false; modalReagendamentoVisivel = true; }
  function fecharModais() { modalAcoesVisivel = false; modalCancelamentoVisivel = false; modalReagendamentoVisivel = false; agendamentoSelecionado = null; }

  // API PARA ALTERAR STATUS DE CONFIRMADO OU COMPARECEU
  async function alterarStatus(agendamento, tipo) {
    dispatch('loading', true);
    const url = Constantes.api_acesso.replace('acesso.php', 'alterar_status_agendamento.php');
    const res = await conexao.conecta(url, { body: { id_tenant: tenant.id, id_agendamento: agendamento.id, tipo: tipo } });
    dispatch('loading', false);
    modalAcoesVisivel = false;
    dispatch('recarregar', res?.mensagem);
  }

  async function confirmarCancelamento() {
    dispatch('loading', true);
    const url = Constantes.api_acesso.replace('acesso.php', 'cancelar_agendamento.php');
    const res = await conexao.conecta(url, { body: { id_tenant: tenant.id, id_agendamento: agendamentoSelecionado.id, restaurar: restaurarHorario } });
    dispatch('loading', false);
    fecharModais();
    dispatch('recarregar', res?.mensagem || 'Agendamento cancelado com sucesso.');
  }

  async function confirmarReagendamento() {
    if (!novoIdHorario) { alert("Selecione o novo horário."); return; }
    dispatch('loading', true);
    const url = Constantes.api_acesso.replace('acesso.php', 'reagendar_agendamento.php');
    const res = await conexao.conecta(url, { body: { id_tenant: tenant.id, id_agendamento: agendamentoSelecionado.id, novo_id_horario: novoIdHorario, restaurar_antigo: restaurarHorario } });
    dispatch('loading', false);
    fecharModais();
    dispatch('recarregar', res?.mensagem || 'Agendamento remarcado com sucesso.');
  }
</script>

<section class="card-panel fade-in">
  <div class="header-flex">
    <h2>Agenda de Clientes</h2>
    <div class="view-switcher">
      <button class:active={visaoAgendamentos === 'calendario'} on:click={() => visaoAgendamentos = 'calendario'}><i class="far fa-calendar-alt"></i></button>
      <button class:active={visaoAgendamentos === 'lista'} on:click={() => visaoAgendamentos = 'lista'}><i class="fas fa-list"></i></button>
    </div>
  </div>

  {#if agendamentos.length === 0}
    <div class="empty text-muted text-center" style="padding: 40px 0;">Nenhum agendamento realizado ainda.</div>
  {:else if visaoAgendamentos === 'lista'}
    
    <div class="filter-bar fade-in desktop-filters">
      <div class="filter-group" style="flex: 2; min-width: 200px;">
        <i class="fas fa-search filter-icon"></i>
        <input type="text" class="input-app pl-icon" bind:value={termoBusca} placeholder="Buscar cliente..." />
      </div>
      <div class="filter-group">
        <select class="input-app" bind:value={filtroLocal}>
          <option value="">Todos os locais</option>
          {#each locaisDisponiveis as loc} <option value={loc}>{loc}</option> {/each}
        </select>
      </div>
      <div class="filter-group">
        <select class="input-app" bind:value={filtroPeriodo}>
          <option value="todos">Período (Todos)</option>
          <option value="futuros">Próximas Consultas</option>
          <option value="passados">Consultas Anteriores</option>
        </select>
      </div>
      <div class="filter-group">
        <select class="input-app" bind:value={filtroStatus}>
          <option value="todos">Status (Todos)</option>
          <option value="aguardando">Aguardando Confirmação</option>
          <option value="confirmados">Confirmados</option>
          <option value="compareceram">Compareceram</option>
        </select>
      </div>
    </div>

    <details class="mobile-filters fade-in">
      <summary>
        <span><i class="fas fa-sliders-h"></i> Filtros</span>
        <i class="fas fa-chevron-down"></i>
      </summary>
      <div class="filter-bar">
        <div class="filter-group" style="flex: 2; min-width: 200px;">
          <i class="fas fa-search filter-icon"></i>
          <input type="text" class="input-app pl-icon" bind:value={termoBusca} placeholder="Buscar cliente..." />
        </div>
        <div class="filter-group">
          <select class="input-app" bind:value={filtroLocal}>
            <option value="">Todos os locais</option>
            {#each locaisDisponiveis as loc} <option value={loc}>{loc}</option> {/each}
          </select>
        </div>
        <div class="filter-group">
          <select class="input-app" bind:value={filtroPeriodo}>
            <option value="todos">Período (Todos)</option>
            <option value="futuros">Próximas Consultas</option>
            <option value="passados">Consultas Anteriores</option>
          </select>
        </div>
        <div class="filter-group">
          <select class="input-app" bind:value={filtroStatus}>
            <option value="todos">Status (Todos)</option>
            <option value="aguardando">Aguardando Confirmação</option>
            <option value="confirmados">Confirmados</option>
            <option value="compareceram">Compareceram</option>
          </select>
        </div>
      </div>
    </details>

    <div class="table-scroll fade-in mt-3">
      {#if agendamentosProcessados.length === 0}
        <div class="empty text-muted text-center" style="padding: 30px 0;">Nenhum agendamento encontrado.</div>
      {:else}
        <table class="app-table">
          <thead>
            <tr>
              <th>Data/Hora</th>
              <th>Cliente</th>
              <th>Status</th>
              <th class="text-center">Ações</th>
            </tr>
          </thead>
          <tbody>
            {#each agendamentosProcessados as a}
              <tr class={a.compareceu == 1 ? 'row-attended' : (a.confirmado == 1 ? 'row-confirmed' : '')}>
                <td data-label="Data/Hora">{formatarData(a.data_hora)} às {a.data_hora.split(' ')[1].substring(0,5)}</td>
                <td data-label="Cliente" class="fw-bold cliente-cell" on:click={() => abrirAcoesCalendario(a)}>
                  <span class="cliente-link">{a.nome_cliente}</span>
                  <span class="badge-type mt-1">{a.local || 'Consultório'}</span>
                </td>
                
                <td data-label="Status">
                  {#if a.compareceu == 1}
                    <span class="badge-status status-attended"><i class="fas fa-check-double"></i> Compareceu</span>
                  {:else if a.confirmado == 1}
                    <span class="badge-status status-confirmed"><i class="fas fa-thumbs-up"></i> Confirmado</span>
                  {:else}
                    <span class="badge-status status-pending"><i class="far fa-clock"></i> Aguardando</span>
                  {/if}
                </td>

                <td data-label="Ações" class="text-center" style="vertical-align: middle;">
                  <div class="action-cell">
                    <a href="https://wa.me/55{a.telefone}" class="btn-icon text-whatsapp" target="_blank" title="WhatsApp" on:click|stopPropagation><i class="fab fa-whatsapp"></i></a>
                    
                    <button class="btn-icon {a.confirmado == 1 ? 'text-confirmed' : 'text-muted'}" on:click|stopPropagation={() => alterarStatus(a, 'confirmado')} title="Confirmado (Intenção)">
                      <i class={a.confirmado == 1 ? "fas fa-thumbs-up" : "far fa-thumbs-up"}></i>
                    </button>

                    <button class="btn-icon {a.compareceu == 1 ? 'text-attended' : 'text-muted'}" on:click|stopPropagation={() => alterarStatus(a, 'compareceu')} title="Compareceu (Presença)">
                      <i class={a.compareceu == 1 ? "fas fa-check-double" : "fas fa-check"}></i>
                    </button>

                    <button class="btn-icon {a.ausente == 1 ? 'text-danger' : 'text-muted'}" on:click|stopPropagation={() => alterarStatus(a, 'ausente')} title="Faltou (Ausência)">
                      <i class="fas fa-user-times"></i>
                    </button>

                    <button class="btn-icon text-warning" on:click|stopPropagation={() => iniciarReagendamento(a)} title="Reagendar"><i class="fas fa-calendar-day"></i></button>
                    <button class="btn-icon text-danger" on:click|stopPropagation={() => iniciarCancelamento(a)} title="Cancelar"><i class="fas fa-times-circle"></i></button>
                  </div>
                </td>
              </tr>
            {/each}
          </tbody>
        </table>
      {/if}
    </div>
  {:else}
    <div class="calendar-box fade-in">
      <div class="cal-nav">
        <button on:click={() => mudarMes(-1)}><i class="fas fa-chevron-left"></i></button>
        <h3>{nomeMesAtual} {anoAtual}</h3>
        <button on:click={() => mudarMes(1)}><i class="fas fa-chevron-right"></i></button>
      </div>
      <div class="cal-grid">
        {#each ['D','S','T','Q','Q','S','S'] as d} <div class="cal-weekday">{d}</div> {/each}
        {#each diasCalendario as dia}
          <div class="cal-day {dia ? '' : 'empty'} {dia && dia === new Date().getDate() && mesAtual === new Date().getMonth() && anoAtual === new Date().getFullYear() ? 'today' : ''}">
            {#if dia}
              <span class="day-num">{dia}</span>
              <div class="day-events">
                {#each agendamentosDoDia(dia) as ev}
                  <div class="ev-tag clickable" class:attended-tag={ev.compareceu == 1} class:confirmed-tag={ev.compareceu == 0 && ev.confirmado == 1} title="Local: {ev.local || 'Consultório'}" on:click={() => abrirAcoesCalendario(ev)}>
                    <b>{ev.data_hora.split(' ')[1].substring(0,5)}</b> 
                    {#if ev.compareceu == 1}<i class="fas fa-check-double"></i> {:else if ev.confirmado == 1}<i class="fas fa-thumbs-up"></i> {/if}
                    {ev.nome_cliente.split(' ')[0]}
                  </div>
                {/each}
              </div>
            {/if}
          </div>
        {/each}
      </div>
    </div>
  {/if}
</section>

{#if modalAcoesVisivel}
  <div class="modal-overlay fade-in" on:mousedown={fecharModais}>
    <div class="modal-card" on:mousedown|stopPropagation>
      <button class="close-btn" on:click={fecharModais}><i class="fas fa-times"></i></button>
      <h3>Gerenciar Agendamento</h3>
      <div class="user-details mt-3 mb-4 text-left">
        <p><strong>Cliente:</strong> {agendamentoSelecionado.nome_cliente}</p>
        <p><strong>Data:</strong> {formatarData(agendamentoSelecionado.data_hora)} às {agendamentoSelecionado.data_hora.split(' ')[1].substring(0,5)}</p>
      </div>

      <div class="details-card mt-2 mb-4">
        <h4>Dados do cliente</h4>
        <div class="detail-grid">
          <div>
            <span class="detail-label">CPF</span>
            <p>{agendamentoSelecionado.cpf || 'Não informado'}</p>
          </div>
          <div>
            <span class="detail-label">Telefone</span>
            <p>{agendamentoSelecionado.telefone || 'Não informado'}</p>
          </div>
          <div class="detail-full">
            <span class="detail-label">E-mail</span>
            <p>{agendamentoSelecionado.email || 'Não informado'}</p>
          </div>
          <div class="detail-full">
            <span class="detail-label">Endereço</span>
            <p>{agendamentoSelecionado.endereco_paciente || agendamentoSelecionado.endereco || 'Não informado'}</p>
          </div>
          {#if (agendamentoSelecionado.observacoes && agendamentoSelecionado.observacoes.trim() !== '') || (tenant && tenant.campo_observacoes !== 'oculto')}
            <div class="detail-full">
              <span class="detail-label">{obterLabelObservacoes(agendamentoSelecionado)}</span>
              <p>{agendamentoSelecionado.observacoes || 'Não informado'}</p>
            </div>
          {/if}
        </div>
      </div>

      <div class="modal-actions-grid" style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px;">
        <button class="btn-outline w-100" style="color: {agendamentoSelecionado.confirmado == 1 ? '#3182ce' : '#777'}; border-color: {agendamentoSelecionado.confirmado == 1 ? '#3182ce' : '#ddd'};" on:click={() => alterarStatus(agendamentoSelecionado, 'confirmado')}>
          <i class="fas fa-thumbs-up"></i> {agendamentoSelecionado.confirmado == 1 ? 'Desmarcar' : 'Confirmar'}
        </button>
        <button class="btn-outline w-100" style="color: {agendamentoSelecionado.compareceu == 1 ? '#38a169' : '#777'}; border-color: {agendamentoSelecionado.compareceu == 1 ? '#38a169' : '#ddd'};" on:click={() => alterarStatus(agendamentoSelecionado, 'compareceu')}>
          <i class="fas fa-check-double"></i> {agendamentoSelecionado.compareceu == 1 ? 'Retirar Presença' : 'Compareceu'}
        </button>
        
        <button class="btn-outline w-100" style="grid-column: 1 / -1;" on:click={() => iniciarReagendamento(agendamentoSelecionado)}><i class="fas fa-calendar-day"></i> Reagendar</button>
        <button class="btn-danger w-100" style="grid-column: 1 / -1;" on:click={() => iniciarCancelamento(agendamentoSelecionado)}><i class="fas fa-times-circle"></i> Cancelar</button>
      </div>
    </div>
  </div>
{/if}

{#if modalCancelamentoVisivel}
  <div class="modal-overlay fade-in" on:mousedown={fecharModais}>
    <div class="modal-card" on:mousedown|stopPropagation>
      <button class="close-btn" on:click={fecharModais}><i class="fas fa-times"></i></button>
      <h3 style="color: #c53030;">Confirmar Cancelamento</h3>
      <p class="text-muted mt-2">Tem certeza que deseja cancelar a consulta de <strong>{agendamentoSelecionado.nome_cliente}</strong>?</p>
      <div class="switch-row mt-4 mb-4 text-left p-3" style="background: #f8faf9; border-radius: 8px; border: 1px solid var(--border);">
        <label class="switch"><input type="checkbox" bind:checked={restaurarHorario}><span class="slider"></span></label>
        <span class="fw-bold" style="font-size: 0.9rem;">Disponibilizar este horário novamente na agenda?</span>
      </div>
      <button class="btn-danger w-100" on:click={confirmarCancelamento}>Sim, Cancelar Consulta</button>
      <button class="btn-link mt-2" on:click={fecharModais}>Voltar</button>
    </div>
  </div>
{/if}

{#if modalReagendamentoVisivel}
  <div class="modal-overlay fade-in" on:mousedown={fecharModais}>
    <div class="modal-card" on:mousedown|stopPropagation>
      <button class="close-btn" on:click={fecharModais}><i class="fas fa-times"></i></button>
      <h3>Reagendar Consulta</h3>
      <p class="text-muted mt-2">Cliente: <strong>{agendamentoSelecionado.nome_cliente}</strong></p>
      <div class="text-left mt-3">
        <label>Escolha o novo horário:</label>
        <select class="input-app" bind:value={novoIdHorario}>
          <option value="">Selecione um horário disponível...</option>
          {#each horarios.filter(h => new Date(h.inicio.replace(/-/g, '/')) >= new Date()) as h}
            <option value={h.id}>{formatarData(h.inicio)} às {h.inicio.split(' ')[1].substring(0,5)} - {h.local || 'Consultório'}</option>
          {/each}
        </select>
      </div>
      <div class="switch-row mt-4 mb-4 text-left p-3" style="background: #f8faf9; border-radius: 8px; border: 1px solid var(--border);">
        <label class="switch"><input type="checkbox" bind:checked={restaurarHorario}><span class="slider"></span></label>
        <span class="fw-bold" style="font-size: 0.85rem;">Liberar o horário antigo ({agendamentoSelecionado.data_hora.split(' ')[1].substring(0,5)}) na agenda?</span>
      </div>
      <button class="btn-primary w-100" on:click={confirmarReagendamento}>Confirmar Reagendamento</button>
      <button class="btn-link mt-2" on:click={fecharModais}>Cancelar</button>
    </div>
  </div>
{/if}

<style>
  .header-flex { display: flex; justify-content: space-between; align-items: center; margin-bottom: 25px; }
  .view-switcher { display: flex; background: var(--bg-app); border-radius: 8px; padding: 4px; }
  .view-switcher button { border: none; background: transparent; padding: 8px 12px; border-radius: 6px; cursor: pointer; color: #888; }
  .view-switcher button.active { background: white; color: var(--primary); box-shadow: 0 2px 5px rgba(0,0,0,0.1); }

  .filter-bar { display: flex; gap: 10px; background: #f8faf9; padding: 15px; border-radius: 12px; border: 1px solid var(--border); flex-wrap: wrap; }
  .filter-group { flex: 1; min-width: 140px; position: relative; }
  .filter-icon { position: absolute; left: 12px; top: 50%; transform: translateY(-50%); color: #999; }
  .pl-icon { padding-left: 35px !important; }

  .desktop-filters { display: flex; }
  .mobile-filters { display: none; margin-bottom: 12px; }
  .mobile-filters summary {
    list-style: none;
    cursor: pointer;
    background: #f8faf9;
    border: 1px solid var(--border);
    border-radius: 12px;
    padding: 12px 14px;
    font-weight: 700;
    color: var(--text-main);
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }
  .mobile-filters summary::-webkit-details-marker { display: none; }
  .mobile-filters .filter-bar { margin-top: 10px; border-top-left-radius: 0; border-top-right-radius: 0; border-top: none; }
  .mobile-filters[open] summary { border-bottom-left-radius: 0; border-bottom-right-radius: 0; }
  .mobile-filters[open] summary .fa-chevron-down { transform: rotate(180deg); }
  .mobile-filters .fa-chevron-down { transition: transform 0.2s ease; }

  /* CORES DOS 3 STATUS */
  .badge-status { padding: 4px 10px; border-radius: 6px; font-size: 0.75rem; font-weight: 700; display: inline-block; white-space: nowrap; }
  .status-attended { background: #c6f6d5; color: #22543d; border: 1px solid #9ae6b4; } /* Verde Forte */
  .status-confirmed { background: #bee3f8; color: #2a4365; border: 1px solid #90cdf4; } /* Azul/Verde Claro */
  .status-pending { background: #edf2f7; color: #4a5568; border: 1px solid #e2e8f0; } /* Cinza */
  
  .row-confirmed { background-color: #f0f8ff; } 
  .row-attended { background-color: #f0fff4; opacity: 0.9; }

  .cliente-cell { cursor: pointer; display: flex; flex-direction: column; align-items: flex-start; gap: 6px; }
  .cliente-link { color: var(--primary); font-weight: 700; text-decoration: underline; text-decoration-color: transparent; transition: text-decoration-color 0.2s ease; }
  .cliente-cell:hover .cliente-link { text-decoration-color: var(--primary); }

  .details-card { background: #f8faf9; border: 1px solid var(--border); border-radius: 12px; padding: 16px; text-align: left; }
  .details-card h4 { margin: 0 0 12px; font-size: 1rem; color: var(--text-main); }
  .detail-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; }
  .detail-full { grid-column: 1 / -1; }
  .detail-label { display: block; font-size: 0.75rem; font-weight: 700; color: #718096; text-transform: uppercase; letter-spacing: 0.04em; margin-bottom: 4px; }
  .detail-grid p { margin: 0; color: var(--text); font-size: 0.95rem; line-height: 1.5; word-break: break-word; }

  .cal-nav { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; }
  .cal-nav button { background: var(--bg-app); border: none; width: 35px; height: 35px; border-radius: 50%; cursor: pointer; }
  .cal-grid { display: grid; grid-template-columns: repeat(7, 1fr); gap: 1px; background: var(--border); border-radius: 10px; overflow: hidden; min-width: 600px; }
  .cal-weekday { background: #f8faf9; padding: 10px; text-align: center; font-weight: 700; font-size: 0.7rem; color: #999; }
  .cal-day { background: white; min-height: 100px; padding: 8px; position: relative; }
  .cal-day.empty { background: #fcfcfc; }
  .day-num { font-size: 0.8rem; font-weight: 700; opacity: 0.5; }
  .cal-day.today { background: #fffcf5; box-shadow: inset 0 0 0 2px var(--accent); }
  .cal-day.today .day-num { color: var(--accent); opacity: 1; }
  
  .day-events { margin-top: 5px; display: flex; flex-direction: column; gap: 3px; max-height: 120px; overflow-y: auto; }
  .ev-tag { font-size: 0.65rem; padding: 3px 5px; border-radius: 4px; background: #edf2f7; color: #4a5568; border-left: 3px solid #cbd5e0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; cursor: pointer; }
  .confirmed-tag { background: #ebf8ff; color: #2a4365; border-left-color: #4299e1; } /* Azul claro */
  .attended-tag { background: #f0fff4; color: #22543d; border-left-color: #48bb78; } /* Verde escuro */
  
  .calendar-box { overflow-x: auto; }

  .action-cell { display: flex; gap: 8px; justify-content: center; }
  .btn-icon { background: none; border: none; font-size: 1.1rem; cursor: pointer; padding: 5px; opacity: 0.7; transition: 0.2s; }
  .btn-icon:hover { opacity: 1; transform: scale(1.1); }
  .text-whatsapp { color: #25d366; }
  .text-confirmed { color: #3182ce; opacity: 1; }
  .text-attended { color: #38a169; opacity: 1; }
  .text-warning { color: #d69e2e; }
  .text-danger { color: #e53e3e; }
  .text-muted { color: #a0aec0; }

  /* MODAIS GLOBAIS */
  .modal-overlay { position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; background: rgba(0, 0, 0, 0.6); backdrop-filter: blur(4px); z-index: 9999; display: flex; align-items: center; justify-content: center; }
  .modal-card { background: white; padding: 30px; border-radius: 16px; width: 100%; max-width: 450px; position: relative; box-shadow: 0 10px 40px rgba(0,0,0,0.2); text-align: center; }
  .close-btn { position: absolute; top: 15px; right: 15px; background: none; border: none; font-size: 1.2rem; color: #999; cursor: pointer; }
  .btn-danger { background: #e53e3e; color: white; border: none; padding: 14px; border-radius: 8px; font-weight: 700; cursor: pointer; transition: 0.3s; }
  .btn-outline { background: transparent; border: 1px solid var(--border); color: var(--text); padding: 12px; border-radius: 8px; font-weight: 700; cursor: pointer; transition: 0.3s; }
  .btn-primary { background: var(--primary); color: white; border: none; padding: 14px; border-radius: 8px; font-weight: 700; cursor: pointer; transition: 0.3s; }
  .btn-link { background: none; border: none; color: #777; cursor: pointer; font-size: 0.85rem; text-decoration: underline; }
  
  .switch-row { display: flex; align-items: center; gap: 12px; }
  .switch { position: relative; display: inline-block; width: 40px; height: 20px; flex-shrink: 0; }
  .switch input { opacity: 0; width: 0; height: 0; }
  .slider { position: absolute; cursor: pointer; top: 0; left: 0; right: 0; bottom: 0; background-color: #ccc; transition: .4s; border-radius: 20px; }
  .slider:before { position: absolute; content: ""; height: 14px; width: 14px; left: 3px; bottom: 3px; background-color: white; transition: .4s; border-radius: 50%; }
  input:checked + .slider { background-color: var(--primary); }
  input:checked + .slider:before { transform: translateX(20px); }

  @media (max-width: 768px) {
    .header-flex { flex-direction: column; align-items: flex-start; gap: 12px; }
    .view-switcher { width: 100%; justify-content: space-between; }
    .desktop-filters { display: none; }
    .mobile-filters { display: block; }
    .filter-bar { flex-direction: column; }
    .filter-group { width: 100%; }

    .table-scroll { overflow-x: hidden; }
    .app-table, .app-table thead, .app-table tbody, .app-table tr, .app-table th, .app-table td { display: block; width: 100%; }
    .app-table thead { display: none; }
    .app-table tbody tr {
      border: 1px solid var(--border);
      border-radius: 14px;
      padding: 14px;
      margin-bottom: 12px;
      background: white;
    }
    .app-table tbody tr td {
      border: none;
      padding: 4px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;
      flex-wrap: wrap;
      text-align: left !important;
      color: var(--text-main);
    }
    .app-table tbody tr td::before {
      content: attr(data-label);
      color: #718096;
      font-size: 0.72rem;
      font-weight: 800;
      text-transform: uppercase;
      letter-spacing: 0.05em;
      display: inline-block;
      flex: 0 0 72px;
    }
    .app-table tbody tr td > * {
      flex: 1 1 auto;
      min-width: 0;
    }
    .app-table tbody tr td:last-child {
      margin-top: 8px;
      padding-top: 8px;
      border-top: 1px solid var(--border);
      display: block;
      width: 100%;
    }
    .app-table tbody tr td:last-child::before {
      margin-bottom: 8px;
      display: block;
    }
    .cliente-cell {
      align-items: flex-start;
      flex-direction: row;
      flex-wrap: wrap;
    }
    .cliente-cell > * {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      flex-wrap: wrap;
    }
    .badge-type { margin-top: 0; }
    .action-cell {
      justify-content: flex-start;
      flex-wrap: wrap;
      width: 100%;
    }

    .cal-grid { min-width: 100%; }
    .modal-card { padding: 20px 16px; }
    .modal-actions-grid { grid-template-columns: 1fr !important; }
  }

  @media (max-width: 480px) {
    .action-cell { flex-wrap: wrap; }
    .cal-day { min-height: 90px; }
  }
</style>